import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function NewCricBuddyPortfolioClientRequirements() {
  const data = [
    "Web application and native mobile apps (iOS and Android)",
    "User-friendly interface for effortless venue search and online booking",
    "Mobile responsiveness and intuitive design",
    "Secure, seamless payments and instant booking notifications",
    "Venue management dashboard for owners",
    "Real-time booking online/offline mode, recurring slots, and flexible cancellation",
    "Automated notifications and team/player search abilities",
  ];

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const isMobile = window.innerWidth < 768;

  return (
    <div className="horizontal-padding pb-5" ref={ref}>
      <div className="border-el-wrapper">
        <span className="b1"></span>
        <span className="b2"></span>
        <span className="b3"></span>
        <span className="b4"></span>

        <div className="row">
          {/* Left Section */}
          <motion.div
            className="col-md-6 col-12 mb-4 mb-md-0"
            initial={
              isMobile ? { y: 100, opacity: 0 } : { x: -100, opacity: 0 }
            }
            animate={inView ? { x: 0, y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h2 className="cb-cr-heading mb-4">Client Requirements</h2>
            {data.map((val, idx) => (
              <h3
                className={`cb-cr-h3 ${
                  idx === data.length - 1 ? "border-0" : ""
                }`}
                key={idx}
              >
                {val}
              </h3>
            ))}
          </motion.div>

          {/* Right Section */}
          <motion.div
            className="col-md-6 col-12 text-center"
            initial={isMobile ? { y: 100, opacity: 0 } : { x: 100, opacity: 0 }}
            animate={inView ? { x: 0, y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <img
              src="/images/CB/ClientRequirementsImg.png"
              alt="Client Requirements"
              className="img-fluid cb-cr-img"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}
